import { Box, Card, CardContent, Stack, Typography } from "@mui/material";

import classes from "./Packages.module.css";
import { packagesData } from "./packagesData";
import { BOOKING_URL, trackBookingClick } from "../../utils/tracking";
import useDocumentMeta from "../../utils/useDocumentMeta";
import BookingWidgetSection from "../../Components/BookingWidget/BookingWidgetSection";

const Packages = () => {
  useDocumentMeta(
    "Treatment Packages | Radiance Aesthetics | Hindley | Wigan",
    "Save on course packages for Microneedling and other results-driven treatments at Radiance Aesthetics, Hindley, Wigan. Nurse-led care with package pricing.",
  );

  return (
    <section className={classes.packagesSection}>
      <Stack
        sx={{
          maxWidth: "720px",
          margin: "0 auto",
          alignItems: "center",
          padding: { xs: "20px 16px", md: "20px 24px" },
        }}
      >
        <Typography
          sx={{
            fontFamily: "var(--font-body)",
            fontSize: "12px",
            fontWeight: 600,
            letterSpacing: "2.5px",
            textTransform: "uppercase",
            color: "var(--color-accent)",
            textAlign: "center",
            mb: 1.5,
          }}
        >
          Save on Courses
        </Typography>
        <Typography
          sx={{
            fontFamily: "var(--font-heading)",
            color: "var(--color-primary)",
            fontWeight: 400,
            textAlign: "center",
            fontSize: { xs: "28px", md: "40px" },
            mb: 1.5,
          }}
          variant="h1"
        >
          Treatment Packages
        </Typography>

        <Typography
          sx={{
            color: "var(--color-text-light)",
            textAlign: "center",
            fontSize: "16px",
            mb: 5,
            maxWidth: "600px",
            lineHeight: 1.7,
            fontFamily: "var(--font-body)",
          }}
        >
          Commit to your skin journey and save with our course packages.
          Packages are available for our most results-driven treatments.
        </Typography>

        <Stack sx={{ width: "100%" }} gap={2.5}>
          {packagesData.map((pkg) => (
            <Card
              key={pkg.id}
              sx={{
                borderRadius: "8px",
                boxShadow: "none",
                backgroundColor: "white",
                border: "1px solid var(--color-border)",
                transition: "all 0.3s ease",
                "&:hover": {
                  boxShadow: "0 4px 20px rgba(90, 77, 71, 0.1)",
                },
              }}
            >
              <CardContent sx={{ p: { xs: 2.5, md: 3 } }}>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  justifyContent="space-between"
                  alignItems={{ xs: "flex-start", sm: "center" }}
                  gap={2}
                >
                  <Stack>
                    <Typography
                      sx={{
                        color: "var(--color-primary)",
                        fontWeight: 600,
                        fontFamily: "var(--font-body)",
                        fontSize: "16px",
                        mb: 0.5,
                      }}
                    >
                      {pkg.name}
                    </Typography>
                    <Typography
                      sx={{
                        color: "var(--color-text-muted)",
                        fontFamily: "var(--font-body)",
                        fontSize: "14px",
                      }}
                    >
                      {pkg.sessions} sessions
                    </Typography>
                  </Stack>
                  <Stack
                    direction="column"
                    alignItems={{ xs: "flex-start", sm: "flex-end" }}
                    gap={0.5}
                  >
                    <Stack direction="row" gap={1.5} alignItems="baseline">
                      <Typography
                        sx={{
                          color: "var(--color-primary)",
                          fontWeight: 700,
                          fontSize: "22px",
                          fontFamily: "var(--font-body)",
                        }}
                      >
                        £{pkg.price}
                      </Typography>
                      <Typography
                        sx={{
                          textDecoration: "line-through",
                          color: "var(--color-text-muted)",
                          fontWeight: 500,
                          fontSize: "15px",
                          fontFamily: "var(--font-body)",
                        }}
                      >
                        £{pkg.rrp}
                      </Typography>
                    </Stack>
                    <Box>
                      <Typography
                        component="span"
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          borderRadius: "4px",
                          px: 1.25,
                          py: 0.25,
                          fontWeight: 600,
                          fontSize: "13px",
                          fontFamily: "var(--font-body)",
                          color: "#2e7d32",
                          backgroundColor: "rgba(46, 125, 50, 0.08)",
                          border: "1px solid rgba(46, 125, 50, 0.2)",
                        }}
                      >
                        Save £{pkg.rrp - pkg.price}
                      </Typography>
                    </Box>
                  </Stack>
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Stack>

        <Box
          sx={{
            mt: 5,
            p: 3,
            backgroundColor: "var(--color-white)",
            borderRadius: "8px",
            width: "100%",
            border: "1px solid var(--color-border)",
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "15px",
              color: "var(--color-text)",
              fontFamily: "var(--font-body)",
              mb: 2,
              lineHeight: 1.7,
            }}
          >
            Ready to commit to a course of treatments? Get in touch to book your
            package.
          </Typography>
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noreferrer"
            onClick={() => trackBookingClick("Packages")}
            style={{
              display: "inline-block",
              backgroundColor: "#5a4d47",
              color: "#fff",
              padding: "12px 28px",
              borderRadius: "4px",
              textDecoration: "none",
              fontSize: "14px",
              fontWeight: 600,
              fontFamily: "'Montserrat', sans-serif",
              letterSpacing: "0.3px",
              transition: "all 0.3s ease",
            }}
          >
            Book Your Package
          </a>
        </Box>

        <BookingWidgetSection source="Packages" />
      </Stack>
    </section>
  );
};

export default Packages;
